import dayjs from 'dayjs'
import { setLocale } from 'yup'

setLocale({
  date: {
    max: ({ max }) => ({ key: 'yup:date.maxDate', values: { max: dayjs(max).format('DD/MM/YYYY') } }),
    min: ({ min }) => ({ key: 'yup:date:minDate', values: { min: dayjs(min).format('DD/MM/YYYY') } }),
  },
  mixed: {
    required: 'yup:mixed.required',
    notType: ({ type }) => ({ key: 'yup:mixed.notType', values: { context: type } }),
  },
  number: {
    min: ({ min }) => ({ key: 'yup:number.min', values: { min } }),
    max: ({ max }) => ({ key: 'yup:number.max', values: { max } }),
    lessThan: ({ less }) => ({ key: 'yup:number.less', values: { less } }),
    moreThan: ({ more }) => ({ key: 'yup:number.more', values: { more } }),
  },
  string: {
    email: 'yup:string.email',
    min: ({ min }) => ({ key: 'yup:string.minLength', values: { count: min } }),
    max: ({ max }) => ({ key: 'yup:string.maxLength', values: { count: max } }),
  },
})
